<div class="sidebar-header">
  <p class="sidebar-title group-500">Files</p>
  <pill [value]="files().length" color="primary" size="small" />
</div>

<ul aria-label="Files" role="listbox" class="sidebar-list">
  @for (row of rows(); track trackByIndex($index, row)) {
    <li
      [dataSelector]="'file-preview-sidebar-row-' + row.index"
      tabindex="0"
      role="option"
      class="sidebar-row"
      [attr.aria-selected]="row.index === currentIndex()"
      [attr.title]="row.name"
      [class.sidebar-row--selected]="row.index === currentIndex()"
      [class.sidebar-row--unsupported]="!row.supported"
      (click)="onSelect(row.index)"
      (keydown.enter)="onSelect(row.index)"
      (keydown.space)="onSelect(row.index); $event.preventDefault()"
    >
      <aiwyn-icon name="file" class="sidebar-row-icon" [height]="18" [width]="18" />
      <span class="sidebar-row-name body-400">{{ row.name }}</span>
    </li>
  }
</ul>
